import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CareersHero from './components/CareersHero';
import CareersContent from './components/CareersContent';

const CareersPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <CareersHero />
        <CareersContent />
      </main>
      <Footer />
    </div>
  );
};

export default CareersPage;
